module.exports = __webpack_public_path__ + "static/media/Alyssa Walker.34716816.png";